import React from 'react';
import { Route, Switch } from 'react-router-dom';

const RoutesItemGenerator = ({ routes }) => (
  <Switch>
    {Object.entries(routes).map(
      ([path, props]) => <Route key={path} path={path} {...props} />,
    )}
  </Switch>
);

export default RoutesItemGenerator;
